import { envVarKeys } from './envVarKeys';

export const constants = {
  DEFAULT_LANG: 'en_US',
  DEFAULT_COUNTRY: 'US',
  ITEM_PATH_ROOT: 'root/responsivegrid',
  ITEM_PATH_HEADER: 'root/header-responsivegrid',
  ITEM_PATH_FOOTER: 'root/footer-responsivegrid',
  PAGE_LOADED: 'Page Loaded',
  PAGE_LOADING: 'Page Loading',
  ROUTING_CONFIG: 'routingConfig',
  APPLICATION_NAME: 'shop',
  EXPERIENCE_SEGMENT: ['NOT Logged In'],
  INDEX_FOLLOW: 'index,follow',
  NO_INDEX_NO_FOLLOW: 'noindex,nofollow',
  NO_INDEX_FOLLOW: 'noindex,follow',
  MARRIOTT_DEALS: 'marriottDeals',
  REQUIRED_ASPECT_RATIO: 'CLASSIC',
  ASSET_VARIATION_ICON: 'iconfont',
  IMPERIAL: 'imperial',
  CAMPAIGN_ACTIVE: 'active',
  CAMPAIGN_INACTIVE: 'inactive',
  CHINESE_LANG: 'zh-CN',
};

export const LOCALE_LANGCODE_MAPPING = {
  'it-IT': 'it_IT',
  'ru-RU': 'ru_RU',
  'en-GB': 'en_GB',
  'ko-KR': 'ko_KR',
  'en-US': 'en_US',
  'pt-BR': 'pt_BR',
  'zh-CN': 'zh_CN',
  'fr-FR': 'fr_FR',
  'ja-JP': 'ja_JP',
  'de-DE': 'de_DE',
  'pt-PT': 'pt_PT',
  'es-ES': 'es_ES',
  'pl-PL': 'pl_PL',
  'nl-NL': 'nl_NL',
  'el-GR': 'el_GR',
  'tr-TR': 'tr_TR',
  'th-TH': 'th_TH',
  'vi-VN': 'vi_VI',
  'fi-FI': 'fi_FI',
  'da-DK': 'da_DK',
  'nb-NO': 'nb_NO',
  'sv-SE': 'sv_SE',
  'id-ID': 'id_ID',
  'hi-IN': 'hi_IN',
  'zh-TW': 'zh_TW',
};

export const LOCALE_DOMAIN_MAPPING = {
  it_IT: { domain: '.it', hreflang: 'it-IT' },
  ru_RU: { domain: '.com.ru', hreflang: 'ru-RU' },
  en_GB: { domain: '.co.uk', hreflang: 'en-GB' },
  ko_KR: { domain: '.co.kr', hreflang: 'ko-KR' },
  en_US: { domain: '.com', hreflang: 'en-US' },
  pt_BR: { domain: '.com.br', hreflang: 'pt-BR' },
  zh_CN: { domain: '.com.cn', hreflang: 'zh-CN' },
  fr_FR: { domain: '.fr', hreflang: 'fr-FR' },
  ja_JP: { domain: '.co.jp', hreflang: 'ja-JP' },
  de_DE: { domain: '.de', hreflang: 'de-DE' },
  pt_PT: { domain: '.pt', hreflang: 'pt-PT' },
  es_ES: { domain: '.com', hreflang: 'es' },
  pl_PL: { domain: '.com', hreflang: 'pl' },
  id_ID: { domain: '.com', hreflang: 'id' },
  tr_TR: { domain: '.com', hreflang: 'tr' },
  nl_NL: { domain: '.com', hreflang: 'nl' },
  el_GR: { domain: '.com', hreflang: 'el' },
  th_TH: { domain: '.com', hreflang: 'th' },
  vi_VI: { domain: '.com', hreflang: 'vi' },
  fi_FI: { domain: '.com', hreflang: 'fi' },
  da_DK: { domain: '.com', hreflang: 'da' },
  nb_NO: { domain: '.com', hreflang: 'no' },
  sv_SE: { domain: '.com', hreflang: 'sv' },
  hi_IN: { domain: '.com', hreflang: 'hi' },
  zh_TW: { domain: '.com', hreflang: 'zh-hant' },
};

export const LOCALE_SPECIFIC_MAPPING = {
  en_US: { url: 'https://www.marriott.com', hreflang: 'en-US' },
  it_IT: { url: 'https://www.marriott.com/it', hreflang: 'it-IT' },
  ru_RU: { url: 'https://www.marriott.com/ru', hreflang: 'ru-RU' },
  en_GB: { url: 'https://www.marriott.com/en-gb', hreflang: 'en-GB' },
  ko_KR: { url: 'https://www.marriott.com/ko', hreflang: 'ko-KR' },
  pt_BR: { url: 'https://www.marriott.com/pt-br', hreflang: 'pt-BR' },
  zh_CN: { url: 'https://www.marriott.com.cn', hreflang: 'zh-CN' },
  fr_FR: { url: 'https://www.marriott.com/fr', hreflang: 'fr-FR' },
  ja_JP: { url: 'https://www.marriott.com/ja', hreflang: 'ja-JP' },
  de_DE: { url: 'https://www.marriott.com/de', hreflang: 'de-DE' },
  pt_PT: { url: 'https://www.marriott.com/pt-br', hreflang: 'pt-PT' },
  es_ES: { url: 'https://www.marriott.com/es', hreflang: 'es' },
  pl_PL: { url: 'https://www.marriott.com/pl-pl', hreflang: 'pl' },
  id_ID: { url: 'https://www.marriott.com/id', hreflang: 'id' },
  tr_TR: { url: 'https://www.marriott.com/tr-tr', hreflang: 'tr' },
  nl_NL: { url: 'https://www.marriott.com/nl', hreflang: 'nl' },
  el_GR: { url: 'https://www.marriott.com/el', hreflang: 'el' },
  th_TH: { url: 'https://www.marriott.com/th', hreflang: 'th' },
  vi_VI: { url: 'https://www.marriott.com/vi', hreflang: 'vi' },
  fi_FI: { url: 'https://www.marriott.com/fi', hreflang: 'fi' },
  da_DK: { url: 'https://www.marriott.com/th', hreflang: 'da' },
  nb_NO: { url: 'https://www.marriott.com/no', hreflang: 'no' },
  sv_SE: { url: 'https://www.marriott.com/sv', hreflang: 'sv' },
  hi_IN: { url: 'https://www.marriott.com/hi', hreflang: 'hi' },
  zh_TW: { url: 'https://www.marriott.com/zh-hk', hreflang: 'zh-hant' },
};

export const OFFERS_UXL_CLIENT_NAME = 'phoenix_offers';
export const OFFERS_UXL_CLIENT_VERSION = 'V1';
export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_DESKTOP = 991;
export const DATE_FORMAT_YEAR_MONTH_DAY = 'YYYY-MM-DD';
//commenting details_logger. Since there is build error as m is declared but it's value never read
// export const DETAILS_LOGGER = {
//   debug: (m: string): void => console.log(''), //eslint-disable-line no-console
//   error: (m: string): void => console.log(''), //eslint-disable-line no-console
//   info: (m: string): void => console.log(''), //eslint-disable-line no-console
// };

export const ADD_BUDDHIST_YEAR_VALUE = 543;
export const EN_LOCALE = 'en-US';
export const KO_KR_LOCALE = 'ko-KR';
export const TH_TH_LOCALE = 'th';
export const CN_LOCALE = 'zh-CN';
export const JA_LOCALE = 'ja-JP';
export const DE_LOCALE = 'de-DE';
export const ES_LOCALE = 'es-ES';
export const FR_LOCALE = 'fr-FR';
export const EN_GB_LOCALE = 'en-GB';
export const IT_LOCALE = 'it-IT';
export const PT_LOCALE = 'pt-BR';
export const RU_LOCALE = 'ru-RU';
export const AR_LOCALE = 'ar-AE';
export const HI_LOCALE = 'hi-IN';
export const TH_LOCALE = 'th-TH';
export const NL_LOCALE = 'nl-NL';
export const PL_LOCALE = 'pl-PL';
export const EL_LOCALE = 'el-GR';
export const TR_LOCALE = 'tr-TR';
export const VI_LOCALE = 'vi-VN';
export const FI_LOCALE = 'fi-FI';
export const DA_LOCALE = 'da-DK';
export const NO_LOCALE = 'nb-NO';
export const SV_LOCALE = 'sv-SE';
export const ID_LOCALE = 'id-ID';
export const ZHTW_LOCALE = 'zh-TW';
export const MOCK_SESSION_ID = '7FC3A108-DF69-5E10-B767-6D2FB461B924';
export const IMAGE_CACHE_DOMAIN = 'https://cache.marriott.com';
export const IMAGE_CACHE_DOMAIN_CN = 'https://cache.marriott.com.cn';
export const RZ_HOTEL_DOMAIN = 'https://www.ritzcarlton.com';

export const LOCALE_SUBDIRECTORY_MAPPING = {
  'it-IT': '/it',
  'ru-RU': '/ru',
  'en-GB': '/en-gb',
  'ko-KR': '/ko',
  'en-US': '',
  'pt-BR': '/pt-br',
  'zh-CN': '',
  'fr-FR': '/fr',
  'ja-JP': '/ja',
  'de-DE': '/de',
  'pt-PT': '/pt',
  'es-ES': '/es',
  'nl-NL': '/nl',
  'pl-PL': '/pl-pl',
  'el-GR': '/el',
  'tr-TR': '/tr-tr',
  'th-TH': '/th',
  'vi-VN': '/vi',
  'fi-FI': '/fi',
  'da-DK': '/da',
  'nb-NO': '/no',
  'sv-SE': '/sv',
  'id-ID': '/id',
  'hi-IN': '/hi',
  'zh-TW': '/zh-hk',
};

export const MONTHSHORTVALUE = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const WEEKSDAYSSHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEEKDAYSLONGNAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const INTERNAL_CTA_TYPE = 'Internal';
export const EXTERNAL_CTA_TYPE = 'External';

export const errorTypes = ['invalidDealMsg', 'invalidUserMsg', 'invalidPreviewOffer', 'notEligible'];

export const PRIMARY_MEDIA = 'primary';
export const TERTIARY_MEDIA = 'tertiary';
export const SECONDARY_MEDIA = 'secondary';

export const ASPECT_RATIO_UXL_FIELD_MAPPING = {
  'Wide-Hor': 'wideHorizontal',
  'Pano-Hor': 'panoramicHorizontal',
  'Pano-Ver': 'panoramicVertical',
  'Wide-Ver': 'wideVertical',
  'Feature-Hor': 'featureHorizontal',
  'Feature-Ver': 'featureVertical',
  'Classic-Hor': 'classicHorizontal',
  'Classic-Ver': 'classicVertical',
  Square: 'square',
};
export const ASSET_VARIATION = {
  IMAGE: 'image',
};

export const NEXT_PUBLIC_ENV_KEYS = [
  'NEXT_PUBLIC_SUBMIT_OSERP_URL',
  'NEXT_PUBLIC_SUBMIT_SEARCH_URL',
  'SESSION_GET_CALL_URL_CLIENT',
  'NEXT_PUBLIC_AVAILABILITY_SEARCH_URL',
  'UXL_IMAGE_CACHE_DOMAIN',
  'BAIDU_MAP_API_KEY',
  'TARGET_PROPERTY_TOKEN',
  'NEXT_PUBLIC_SUBMIT_MBE_URL',
  'NEXT_PUBLIC_DAC_LOGO_ENABLE',
  'NEXT_PUBLIC_GRAPHQL_URL',
  ...Object.keys(envVarKeys),
];
export const HOTEL_VIEW = 'hotelView';
export const BREAKPOINT_LARGER_MOBILE = 650;
export const BREAKPOINT_DESKTOP_1023 = 1023;
export const ALLOWED_TAGS_IN_DESCRIPTION = [
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'del',
  'sub',
  'sup',
  'mark',
  'small',
  'big',
  'ul',
  'ol',
  'li',
  'dl',
  'dt',
  'dd',
  'table',
  'tr',
  'td',
  'th',
  'thead',
  'tbody',
  'tfoot',
  'colgroup',
  'col',
  'caption',
  'p',
  'br',
  'hr',
  'blockquote',
  'pre',
  'a',
  'code',
  'span',
  'div',
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
];
export const PANO_HOR_IMG = 'Pano-Hor';
export const WIDE_HOR_IMG = 'Wide-Hor';
export const SQUARE_IMG = 'Square';
export const CLASSIC_VER_IMG = 'Classic-Ver';
export const PANO_ASPECT_RATIO_UXL_FIELD_MAPPING = {
  PANO: 'panoramicHorizontal',
} as const;
export const PARAM_PAGENO = 'pg';
// convert meters distance to miles
export const METERSTOMILES = 1609.344;
//convert miles distance to km
export const METERSTOKM = 1000;
export const CA = 'CA';
export const CANADA = 'Canada';

export const ALERT_TYPES = { CLEAR_ALL_FILTERS: 'clearAllFilters', CURRENCY_UPDATE: 'alertCurrenyUpdateNotification' };
export const CURRENCY_UPDATE_ALERT_CONST = {
  CURRENCY_HEADING: 'Currency Updated',
  CURRENCY_LINK_TEXT: 'Show me rates in local currency.',
  CURRENCY_MESSAGE: 'When you reserve you will see the local currency of the property. ${AlertLinkTextLabel}',
  ICON_TYPE: 'icon-success',
  Alert_TYPE: 'success',
};
export const CLEAR_FILTER_ALERT_CONST = {
  ICON_TYPE: 'icon-warning',
  Alert_TYPE: 'warning',
};
